import React, { useState } from 'react';
import { Label, Legend, Bar, BarChart, Tooltip, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import CardUI from '../../../widgets/layout/CardUI';
import SelectUI from '../../../widgets/input/SelectUI';

const SalesChartUI = ({ monthWiseData, channelWiseData, originatorWiseData,filter }) => {
 
  const getActiveData = () => {
    switch (filter) {
      case 'month':
        return { data: monthWiseData, key: 'month' };
      case 'channel':
        return { data: channelWiseData, key: 'channel' };
      case 'name':
        return { data: originatorWiseData, key: 'name' };
      default:
        return { data: monthWiseData, key: 'month' };
    }
  };

  return (
    <div style={styles.container}>
      <CardUI>
      <h3 style={styles.subHeading}>Contacts & Leads</h3>
      {console.log("originatorWiseData",originatorWiseData,filter)}
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={getActiveData().data} margin={{ top: 20, right: 50, bottom: 40, left: 60 }}>
          {console.log("getActiveData().data",getActiveData().data)}
          <XAxis dataKey={getActiveData().key} textAnchor="end">
            <Label value={filter} position="insideBottom" offset={-10} />
          </XAxis>
          <YAxis yAxisId='left' domain={[0, 'auto']} />
          <YAxis yAxisId='right' orientation='right' domain={[0, 'auto']} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend wrapperStyle={{ bottom: 0 }} />
          <Bar name="Contacts Target" yAxisId="left" dataKey="noOfContactsF" fill="#008080" />
          <Bar name="Contacts Achieved" yAxisId="left" dataKey="contactsAchievedF" fill="#00C49F" />
          <Bar name="New Leads Target" yAxisId="right" dataKey="newLeadTargetF" fill="#FFBB28" />
          <Bar name="New Leads Achieved" yAxisId="right" dataKey="newLeadAchievedF" fill="#FF8042" />
        </BarChart>
      </ResponsiveContainer>
      </CardUI>
      <CardUI className={'g_m_top_100'}>
      <h3 style={styles.subHeading}>Disbursements & Customers</h3>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={getActiveData().data} margin={{ top: 20, right: 50, bottom: 40, left: 60 }}>
          <XAxis dataKey={getActiveData().key}  textAnchor="end">
            <Label value={filter} position="insideBottom" offset={-10} />
          </XAxis>
          <YAxis yAxisId='left' domain={[0, 'auto']} />
          <YAxis yAxisId='right' orientation='right' domain={[0, 'auto']} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend wrapperStyle={{ bottom: 0 }} />
          <Bar name="New Disbursement Target" yAxisId="left" dataKey="newDisbTargetF" fill="#4B0082" />
          <Bar name="New Disbursement Achieved" yAxisId="left" dataKey="newDisbAchievedF" fill="#8A2BE2" />
          <Bar name="Customers Target" yAxisId="right" dataKey="numberOfCustomersF" fill="#32CD32" />
          <Bar name="Customers Achieved" yAxisId="right" dataKey="customersAchievedF" fill="#3CB371" />
        </BarChart>
      </ResponsiveContainer>
      </CardUI>
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
  },
  heading: {
    textAlign: "center",
    color: "#333"
  },
  subHeading: {
    textAlign: "center",
    color: "#555"
  },
};

export default SalesChartUI;